export const currencyFormater = (amount) => {
    if(amount<0)
        amount = 0;
    return Number(amount).toFixed(0);
}